module.exports = __webpack_public_path__ + "img/hr-green-pita-08.c3d8286f.png";